import React from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import iosQRCode from '../assets/qr-codeAF.png';
import androidQRCode from '../assets/qr-code-gps.png';

interface DownloadConfig {
  title?: string;
  subtitle?: string;
  iosUrl?: string;
  androidUrl?: string;
}

interface DownloadSectionProps {
  config?: DownloadConfig;
  onTrackDownload?: (platform: 'ios' | 'android') => void;
}

const DownloadSection: React.FC<DownloadSectionProps> = ({ config, onTrackDownload }) => {
  const title = config?.title ?? 'Download CollectedAF';
  const subtitle = config?.subtitle ?? 'Scan the QR code or click the button to download';
  const iosUrl = config?.iosUrl ?? 'https://apps.apple.com/us/app/collectedaf/id1592301226';
  const androidUrl = config?.androidUrl ?? 'https://play.google.com/store/apps/details?hl=en_US&id=com.collectedAF.collectedAF';
  return (
    <div className="z-20 flex-shrink-0 py-8">
      <div className="relative min-h-[350px] lg:h-[calc(100vh-8rem)]">
        {/* Background Giant C */}
        <div 
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[30rem] opacity-25 pointer-events-none"
          style={{ 
            fontFamily: '"Anton", sans-serif',
            background: 'linear-gradient(135deg, #fbbf24 0%, #f97316 50%, #3b82f6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            filter: 'drop-shadow(0 20px 60px rgba(0,0,0,0.35))'
          }}
        >
          C
        </div>
        
        {/* Download Content */}
        <div className="relative h-full flex items-center justify-center">
          <div className="colorful-ring bg-BLACK/92 backdrop-blur-xl rounded-3xl p-8 lg:p-12 w-full h-auto lg:h-full shadow-2xl flex flex-col items-center justify-center">
            <h2 className="text-5xl font-bold text-WHITE mb-4 text-center">{title}</h2>
            <p className="text-WHITE/80 text-xl mb-12 text-center">{subtitle}</p>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 w-full max-w-4xl">
              {/* iOS App Store */}
              <div className="flex flex-col items-center bg-WHITE/10 backdrop-blur-md rounded-2xl p-8 border border-WHITE/20">
                <FaApple className="text-WHITE mb-4" size={48} />
                <h3 className="text-WHITE text-2xl font-bold mb-4">iOS App Store</h3>
                <div className="bg-WHITE p-4 rounded-xl mb-6">
                  <img 
                    src={iosQRCode} 
                    alt="iOS QR Code" 
                    className="w-48 h-48"
                  />
                </div>
                <a
                  href={iosUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => onTrackDownload?.('ios')}
                  className="bg-WHITE text-BLACK px-8 py-3 rounded-full text-lg font-medium hover:bg-ORANGE hover:text-WHITE transition-colors w-full text-center"
                >
                  Download on App Store
                </a>
              </div>
              
              {/* Google Play Store */}
              <div className="flex flex-col items-center bg-WHITE/10 backdrop-blur-md rounded-2xl p-8 border border-WHITE/20">
                <FaGooglePlay className="text-WHITE mb-4" size={48} />
                <h3 className="text-WHITE text-2xl font-bold mb-4">Google Play Store</h3>
                <div className="bg-WHITE p-4 rounded-xl mb-6">
                  <img 
                    src={androidQRCode} 
                    alt="Android QR Code" 
                    className="w-48 h-48"
                  />
                </div>
                <a
                  href={androidUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => onTrackDownload?.('android')}
                  className="bg-ORANGE text-WHITE px-8 py-3 rounded-full text-lg font-medium hover:bg-WHITE hover:text-BLACK transition-colors w-full text-center"
                >
                  Download on Google Play
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadSection;
